exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sending-progress__title[data-v-b0d2353a]{font-size:1.1rem;margin-bottom:.5rem}.sending-progress__details[data-v-b0d2353a]{font-size:.9rem}", ""]);

// exports
